import { SearchedSpace } from '../providers/SearchResultsProvider';

export const checkAmenities = (
  space: SearchedSpace,
  amenityFilters: string[],
): boolean => {
  if (amenityFilters.length === 0) {
    return true;
  }

  if (space.amenities.length === 0) {
    return false;
  }

  const spaceAmenityIds = space.amenities.map((a) => a.id);

  for (const filterId of amenityFilters) {
    if (!spaceAmenityIds.includes(filterId)) {
      return false;
    }
  }

  return true;
};
